import classNames from "./classNames";

export default function Chip({ active, children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition",
        active ? "bg-blue-600 text-white" : "bg-blue-50 text-blue-700 hover:bg-blue-100"
      )}
    >
      {children}
    </button>
  );
}